import { WhiteLabelConfig } from '../models/whitelabel.model';

/**
 * Configuração padrão do white-label.
 *
 * Este arquivo define a identidade visual padrão da aplicação.
 * Pode ser sobrescrito parcialmente via API (por usuário logado)
 * ou via configuração de deploy.
 *
 * Para customizar por cliente/tenant, o backend pode retornar
 * um Partial<WhiteLabelConfig> que será mesclado sobre estes defaults.
 */
export const WHITELABEL_CONFIG: WhiteLabelConfig = {
  appName: 'Workfinity Vita',
  primaryColor: '#034D33',
  secondaryColor: '#74788d',
  footerText: '',

  lightTheme: {
    logos: {
      logo: 'assets/images/logos/workfinity_vita.svg',
      logoSmall: 'assets/images/logos/workfinity_vita.svg',
      logoLogin: 'assets/images/logos/workfinity_vita.svg',
      favicon: 'favicon.ico',
    },
    header: {
      backgroundColor: '#fdfdfd',
      textColor: '#495057',
    },
    sidebar: {
      backgroundColor: '#fdfdfd',
      menuItemColor: '#333333ff',
      menuItemHoverColor: '#034C34',
      menuItemActiveColor: '#034C34',
      iconColor: '#333333ff',
    },
  },

  darkTheme: {
    logos: {
      logo: 'assets/images/logos/workfinity_vita_branco.svg',
      logoSmall: 'assets/images/logos/workfinity_vita.svg',
      logoLogin: 'assets/images/logos/workfinity_vita.svg',
      favicon: 'favicon.ico',
    },
    header: {
      backgroundColor: '#0d140dff',
      textColor: '#e9ecef',
    },
    sidebar: {
      backgroundColor: '#0d140dff',
      menuItemColor: '#a6b0cf',
      menuItemHoverColor: '#ffffff',
      menuItemActiveColor: '#ffffff',
      iconColor: '#6a7187',
    },
  },
};
